import React from "react";

const OpennewCase = () => {
  return <div>OpennewCase OpennewCase</div>;
};

export default OpennewCase;
